<main>
  <div class="search-wrapper">
    <div class="search-bar-wrapper">
      <div class="search-bar">
        <input type="text" class="form-control" placeholder="Search"
               [(ngModel)]="keyword" (ngModelChange)="filterMatchingUsers()">
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
      <button type="button" class="btn btn-primary" (click)="goToNewUserPage()">New User</button>
    </div>
  </div>

  @if (shownUsers.length > 0) {
    <ul class="users-list">
      @for (user of shownUsers; track user) {
        <li class="user-card">
          <oaibox-user-row [user]="user" [tenant]="user.tenantId ? tenantsMap[user.tenantId] : undefined"></oaibox-user-row>
        </li>
      }
    </ul>
  } @else {
    <div class="users-list empty">
      <strong class="text-muted fs-5">
        No Users
      </strong>
    </div>
  }
</main>
